<template>
  <div class="atelier">
    <nav :class="{'active': menu}">
      <div class="nav-mobile">
        <router-link to="/portfolio">Portfolio</router-link>
        <a>Atelier</a>
        <span class="sub" :class="{'active': filterIsActive('hoje')}" @click="setFilter('hoje');  menu = false">Hoje</span>
        <span class="sub" :class="{'active': filterIsActive('ontem')}"@click="setFilter('ontem');  menu = false">Ontem</span>
        <span class="sub" :class="{'active': filterIsActive('dentro')}" @click="setFilter('dentro');  menu = false">Dentro</span>
        <span class="sub" :class="{'active': filterIsActive('fora')}"@click="setFilter('fora');  menu = false">Fora</span>
        <router-link to="/registos">Registos</router-link>
        <router-link to="/contactos">Contactos</router-link>
      </div>
      <div class="nav-left">
        <router-link to="/portfolio">Portfolio</router-link>
        <span class="separador">&nbsp;</span>
        <span class="current">Atelier</span> <span class="extra">&nbsp;</span> 
        <span class="sub" :class="{'active': filterIsActive('hoje')}" @click="setFilter('hoje');  menu = false">Hoje</span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('ontem')}"@click="setFilter('ontem');  menu = false">Ontem</span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('dentro')}" @click="setFilter('dentro');  menu = false">Dentro</span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('fora')}"@click="setFilter('fora');  menu = false">Fora</span>
      </div>
      <div class="nav-right">
        <router-link to="/registos">Registos</router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/contactos">Contactos</router-link>
      </div>
    </nav>

    <div class="open-menu">
      <div @click="menu = true">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>    

    <carousel class="mecanismos-carousel" :navigationPrevLabel="'❬'" :navigationNextLabel="'❭'"  :navigationEnabled="true" :perPage="1" :paginationEnabled="false">
      <slide class="mecanismos-slide" v-for="item in filterBy(imagens, filter, 'categoria')"  :key="item.id"> 
          <div class="img" :style="{ backgroundImage: 'url(\'' + 'http://atelieradaoparanhos.com' + item.imagem + '\')' }"></div>
      </slide>
    </carousel>


  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2Filters from 'vue2-filters'

export default {
  mixins: [Vue2Filters.mixin],
  name: 'Atelier',
  data () {
    return {
      menu: true,
      filter: 'hoje',
      imagens: ''
    }
  },
  components: {
    Carousel,
    Slide
  },
  mounted: function () {
    this.loadAtelier()
  },
  methods: {
    setFilter: function (newFilter) {
      this.filter = newFilter
    },
    filterIsActive: function (currentFilter) {
      return this.filter === currentFilter
    },
    loadAtelier: function () {
      var app = this
      axios.get('/admin/api/atelier').then((response) => {
        app.imagens = response.data
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


.atelier {
  &-carousel {
    .VueCarousel-slide {
      height: auto;
      img {
        width: 100%;
      }
    }
  }
  &-title {
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-slide {
      height: 100%;
      align-items: center;
      justify-content: center;
      display: flex;
      background-size: cover;
      background-repeat: no-repeat;
  }
}


.mecanismos {
  .nav-left span.current {
  }

  &-carousel {
    .VueCarousel-slide {
      height: calc(100vh - 120px);
    }
  }
  &-title {
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-slide {
      height: 100%;
      .img {
        height: 60vh;
        background-position: center;
        background-size: cover;
      }
      .desc {
        font-family: Georgia;
        color: #6e6e6e;
        font-size: 10px;
        margin: 0 auto;
        height: 50px;
        max-width: 1920px;
        p {
            padding-top: 20px;
            float: left;
            margin-left: 200px;
            float: left;
            max-width: 470px;
        }
      }
  }
}


</style>
